export const ENTRY_DATA_CLINICAL_ENDPOINTS_DESCRIPTION =
  "Clinical Endpoints (Description)";

export const ENTRY_DATA_CLINICAL_ENDPOINTS_DESCRIPTION_KEYS = {
  endpointDescription: "Endpoint Description",
} as const;
